/**
 * Illustrative figures for the marketing scenes (a landlord's sample rent, late fee, a repair
 * receipt). They are never Resida pricing. They are held as numbers and formatted at render, so no
 * dollar amount or day count is written as a literal anywhere under apps/web (BR-107).
 */

export const SAMPLE_FIGURES = {
  rentJordan: 1850,
  rentPriya: 1425,
  rentMaplePartial: 700,
  rentOwed: 1800,
  lateFee: 75,
  listingRent: 1950,
  invoice: 240,
  receipt: 86.12,
  wallDeduction: 180,
  carpetDeduction: 95,
  lateDays: 3,
  leaseEndsInDays: 30,
  /** What e-signature vendors charge per document (a competitor figure, used in feature-page copy). */
  esignLow: 1,
  esignHigh: 3,
} as const;

/** A whole-dollar amount ("$1,850"), or with cents when asked ("$240.00"). */
export function usd(amount: number, withCents = false): string {
  const digits = withCents ? 2 : 0;
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(amount);
}

/** "3 days" / "1 day". */
export function dayCount(n: number): string {
  return `${n} ${n === 1 ? 'day' : 'days'}`;
}
